import React from "react";
import { HiOutlineSparkles } from "react-icons/hi";
import { space, color } from "styled-system";
import styled from "styled-components";

const StyledIcon = styled(HiOutlineSparkles).attrs((props) => ({
  size: props.size,
}))((props) => props.styles, space, color);

const InviteIcon = (props) => {
  return <StyledIcon {...props} />;
};

InviteIcon.defaultProps = {
  size: 22,
  styles: {},
};

export default InviteIcon;
